import { useRoutes, useLocation } from 'react-router-dom';
import { AuthUtils } from '../utils/security';

// routes
import MainRoutes from './MainRoutes';
import AuthenticationRoutes from './AuthenticationRoutes';
import ProtectedRoutes from './ProtectedRoutes';

// ==============================|| ROUTING RENDER ||============================== //

// Component that returns null to allow proxy to handle the route
function ProxyRoute() {
    return null;
}

export default function ThemeRoutes() {
    const location = useLocation();
    const isAuthenticated = AuthUtils.isAuthenticated();

    // Log authentication status in development
    if (process.env.NODE_ENV === 'development') {
        console.log('Authentication status:', isAuthenticated);
    }

    // Exclude public routes that should be handled by backend proxy
    // These routes are server-side rendered and should not be handled by React Router
    const publicBackendRoutes = ['/s/', '/m/', '/og/', '/track'];
    const isPublicBackendRoute = publicBackendRoutes.some(route => location.pathname.startsWith(route));

    // Create proxy routes configuration
    const proxyRoutes = [
        {
            path: '*',
            element: <ProxyRoute />,
        },
    ];

    // Create main routes configuration
    const mainRoutesConfig = !isAuthenticated ? [AuthenticationRoutes] : [MainRoutes];

    // Always call useRoutes - conditionally determine which routes to use
    // This ensures hooks are always called in the same order
    const routes = isPublicBackendRoute ? proxyRoutes : mainRoutesConfig;
    return useRoutes(routes);
}

function NotFound() {
    return <div>Page not found</div>;
}
